import { gql } from "@apollo/client";

export const RECOMMENDATION_EXPLANATION_STATUS_FRAGMENT = gql`
  fragment RecommendationExplanationStatus on RecommendationExplanationStatusObject {
    status
    errorMessage
    explanation {
      id
      explanation
      explanationType
      rating
      feedbackText
      feedbackTags
      feedbackSubmittedDate
    }
  }
`;

// Lightweight polling queries. These select only the id + recommendationExplanationStatus
// on each polled entity so that, combined with fetchPolicy: "no-cache" + cache.writeFragment
// on the response, we update only the explanation-status field on the affected entities and
// don't broadcast cache changes to unrelated active queries (the global watchQuery
// fetchPolicy is "network-only", so a normal refetch causes a cascade of network calls
// across every overlapping query).

export const POLL_CART_EXPLANATION_STATUSES = gql`
  ${RECOMMENDATION_EXPLANATION_STATUS_FRAGMENT}
  query PollCartExplanationStatuses {
    me {
      id
      shoppingCart {
        id
        shoppingcartitemSet {
          id
          recommendationExplanationStatus {
            ...RecommendationExplanationStatus
          }
        }
      }
    }
  }
`;

export const POLL_SUBSCRIPTION_EXPLANATION_STATUSES = gql`
  ${RECOMMENDATION_EXPLANATION_STATUS_FRAGMENT}
  query PollSubscriptionExplanationStatuses {
    me {
      id
      subscription {
        id
        subscriptionwineSet {
          id
          recommendationExplanationStatus {
            ...RecommendationExplanationStatus
          }
        }
      }
      chooseFreeBottleCredits(target: BOX) {
        id
        recommendationExplanationStatus {
          ...RecommendationExplanationStatus
        }
      }
    }
  }
`;

export const SUBMIT_RECOMMENDATION_EXPLANATION_FEEDBACK = gql`
  mutation SubmitRecommendationExplanationFeedback($input: SubmitRecommendationExplanationFeedbackInput!) {
    submitRecommendationExplanationFeedback(input: $input) {
      errors {
        field
        messages
      }
      recommendationExplanation {
        id
        rating
        feedbackText
        feedbackTags
        feedbackSubmittedDate
      }
    }
  }
`;
